import Service, { service } from '@ember/service';
import type { Store } from '@warp-drive/core';
import type { TasApplicationExtension } from 'tio-data/data/resources/tas-application.ext';
import { loadTasApplicationHistory } from 'tio-data/requests/tas-application-actions';

/**
 * Reloads application history for the shared approval components after an action.
 * Apps override `load` to change how actors are labelled; the default keeps the stored labels.
 */
export default class TasApplicationHistoryService extends Service {
  @service declare store: Store;

  /**
   * Fetches the application's history and assigns it to `application.history`.
   *
   * @param application the record whose history is replaced in place
   * @returns the history now assigned to the application
   * @throws when the history request fails
   */
  load = (application: TasApplicationExtension) =>
    loadTasApplicationHistory(this.store, application);
}
